// document.addEventListener('DOMContentLoaded', function () {
//   const firstMediaThumb = document.querySelector('[data-media-position="1"]');
//   if (firstMediaThumb) {
//     requestAnimationFrame(() => firstMediaThumb.click());
//   }

//   const addButton = document.getElementById('bundle-add-to-cart');
//   const variantJsonEl = document.getElementById('bundle-variants-json');
//   const selectedTextEl = document.getElementById('bundle-selected-text');
//   const originalTotalEl = document.getElementById('bundle-total-original');
//   const finalTotalEl = document.getElementById('bundle-total');
//   const selectAllCard = document.getElementById('bundle-select-all');
//   const packFillEl = document.getElementById('bundle-pack-fill');
//   const frontDringInput = document.getElementById('front-dring');
//   const frontDringWrapper = document.getElementById('front-dring-wrapper');

//   const FRONT_DRING_ENABLED = false;
//   const FRONT_DRING_VARIANT_ID = 49176654020863;
//   const errorMessageEl = document.querySelector('.bundle-error-message');

//   const bundleInputs = Array.from(document.querySelectorAll('.bundle-item'));
//   const bundleCards = Array.from(document.querySelectorAll('.bundle-card'));
//   const sizeInputs = Array.from(document.querySelectorAll('input[name="bundle-size"]'));
//   const packOptions = Array.from(document.querySelectorAll('.bundle-pack-option'));

//   if (!addButton || !variantJsonEl || !finalTotalEl || !bundleInputs.length) return;

//   let variants = [];

//   try {
//     variants = JSON.parse(variantJsonEl.textContent);
//   } catch (error) {
//     console.error('Invalid bundle variants JSON:', error);
//     return;
//   }
//   function bundleIncludesHarness(selectedItems) {
//     return selectedItems
//       .map(normalizeItemName)
//       .some((item) => item === 'harness' || item === 'vest');
//   }
//   function updateFrontDringVisibility(selectedItems) {
//     if (!frontDringWrapper || !frontDringInput) return;

//     // Temporarily disable Front D-Ring feature
//     if (!FRONT_DRING_ENABLED) {
//       frontDringWrapper.style.display = 'none';
//       frontDringInput.checked = false;
//       return;
//     }

//     const hasHarness = bundleIncludesHarness(selectedItems);

//     frontDringWrapper.style.display = hasHarness ? '' : 'none';

//     if (!hasHarness) {
//       frontDringInput.checked = false;
//     }
//   }
//   function formatMoney(cents) {
//     if (window.Shopify && Shopify.formatMoney) {
//       return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
//     }

//     return '$' + (cents / 100).toFixed(2);
//   }

//   function getSelectedSize() {
//     const checked = sizeInputs.find((input) => input.checked);
//     return checked ? checked.value : '';
//   }

//   function getSelectedInputs() {
//     return bundleInputs.filter((input) => input.checked);
//   }

//   function getSelectedItems(selectedInputs) {
//     return selectedInputs.map((input) => input.value);
//   }

//   function getDiscountRate(itemCount) {
//     if (itemCount >= 4) return 0.2;
//     if (itemCount === 3) return 0.15;
//     if (itemCount === 2) return 0.1;
//     return 0;
//   }

//   function getBasePriceFromInput(input) {
//     const card = input.closest('.bundle-card');
//     return Number(card?.dataset.priceCents || 0);
//   }

//   function getLivePriceCents(basePriceCents, discountRate) {
//     return Math.round(basePriceCents * (1 - discountRate));
//   }

//   function normalizeItemName(name) {
//     return String(name).trim().toLowerCase();
//   }

//   function getBundleCounts(selectedItems) {
//     const c1Items = ['collar', 'leash'];
//     const c2Items = ['harness', 'vest'];
//     const c3Items = ['bowtie', 'flower', 'bandana', 'poop bag holder'];

//     let c1 = 0;
//     let c2 = 0;
//     let c3 = 0;

//     selectedItems.map(normalizeItemName).forEach((item) => {
//       if (c1Items.includes(item)) c1++;
//       else if (c2Items.includes(item)) c2++;
//       else if (c3Items.includes(item)) c3++;
//     });

//     return { c1, c2, c3 };
//   }

//   function getBundleKey(selectedItems) {
//     const counts = getBundleCounts(selectedItems);
//     return 'Bundle | C1-' + counts.c1 + ' | C2-' + counts.c2 + ' | C3-' + counts.c3;
//   }

//   function findMatchedVariant(selectedItems) {
//     const bundleKey = getBundleKey(selectedItems);
//     return variants.find((variant) => variant.title === bundleKey);
//   }

//   function showBundleError(message) {
//     if (!errorMessageEl) return;

//     errorMessageEl.textContent = message;
//     errorMessageEl.classList.add('is-visible');

//     setTimeout(() => {
//       errorMessageEl.classList.remove('is-visible');
//     }, 3000);
//   }

//   function updateSelectedText(selectedItems) {
//     if (!selectedTextEl) return;
//     selectedTextEl.textContent = selectedItems.length ? selectedItems.join(', ') : 'None selected';
//   }

//   function updateCards(discountRate) {
//     bundleCards.forEach((card) => {
//       const input = card.querySelector('.bundle-item');
//       const priceEl = card.querySelector('[data-price-text]');
//       if (!input || !priceEl) return;

//       card.classList.toggle('is-selected', input.checked);

//       const basePriceCents = Number(card.dataset.priceCents || 0);
//       const livePriceCents = getLivePriceCents(basePriceCents, discountRate);

//       if (discountRate > 0) {
//         priceEl.innerHTML =
//           '<span class="compare-price">' + formatMoney(basePriceCents) + '</span>' +
//           '<span class="sale-price">' + formatMoney(livePriceCents) + '</span>';
//       } else {
//         priceEl.textContent = formatMoney(basePriceCents);
//       }
//     });
//   }

//   function updateTotal(selectedInputs, discountRate) {
//     let originalTotalCents = 0;
//     let finalTotalCents = 0;

//     selectedInputs.forEach((input) => {
//       const basePriceCents = getBasePriceFromInput(input);
//       const livePriceCents = getLivePriceCents(basePriceCents, discountRate);

//       originalTotalCents += basePriceCents;
//       finalTotalCents += livePriceCents;
//     });

//     if (originalTotalEl) {
//       if (discountRate > 0 && originalTotalCents > finalTotalCents) {
//         originalTotalEl.textContent = formatMoney(originalTotalCents);
//         originalTotalEl.style.display = 'inline';
//       } else {
//         originalTotalEl.textContent = '';
//         originalTotalEl.style.display = 'none';
//       }
//     }

//     finalTotalEl.textContent = formatMoney(finalTotalCents);
//     addButton.dataset.totalCents = finalTotalCents;
//   }

//   function updatePackBar(selectedCount) {
//     let fillPercent = 0;
//     let activeCount = 0;

//     if (selectedCount >= 4) {
//       fillPercent = 100;
//       activeCount = 3;
//     } else if (selectedCount === 3) {
//       fillPercent = 66.6667;
//       activeCount = 2;
//     } else if (selectedCount === 2) {
//       fillPercent = 33.3333;
//       activeCount = 1;
//     }

//     if (packFillEl) {
//       packFillEl.style.width = fillPercent + '%';
//     }

//     packOptions.forEach((option, index) => {
//       option.classList.toggle('active', index < activeCount);
//     });
//   }

//   function updateSelectAllState() {
//     if (!selectAllCard) return;

//     const allSelected = bundleInputs.length > 0 && bundleInputs.every((input) => input.checked);
//     selectAllCard.classList.toggle('is-active', allSelected);
//   }

//   function refreshBundleUI() {
//     const selectedInputs = getSelectedInputs();
//     const selectedItems = getSelectedItems(selectedInputs);
//     const discountRate = getDiscountRate(selectedInputs.length);

//     updateSelectedText(selectedItems);
//     updateCards(discountRate);
//     updateTotal(selectedInputs, discountRate);
//     updatePackBar(selectedInputs.length);
//     updateSelectAllState();
//     updateFrontDringVisibility(selectedItems);
//   }

//   function getEngravingProperties() {
//     let payload = null;

//     try {
//       payload = window.__engravingLoadSaved ? window.__engravingLoadSaved() : null;
//     } catch (error) {
//       console.error('Could not load engraving payload:', error);
//     }

//     if (!payload) return {};

//     const props = {};

//     if (payload.line1) props['Engraving Line 1'] = payload.line1;
//     if (payload.line2) props['Engraving Line 2'] = payload.line2;
//     if (payload.line3) props['Engraving Line 3'] = payload.line3;
//     if (payload.font) props['Engraving Font'] = payload.font;
//     if (payload.buckleColor) props['Buckle Color'] = payload.buckleColor;

//     return props;
//   }

//   if (selectAllCard) {
//     selectAllCard.addEventListener('click', function () {
//       const allSelected = bundleInputs.every((input) => input.checked);

//       bundleInputs.forEach((input) => {
//         input.checked = !allSelected;
//       });

//       refreshBundleUI();
//     });
//   }

//   [...bundleInputs, ...sizeInputs].forEach((input) => {
//     input.addEventListener('change', refreshBundleUI);
//   });

//   addButton.addEventListener('click', async function () {
//     if (addButton.disabled) return;

//     const addButtonText = addButton.querySelector('.atc-text');
//     const originalText = addButtonText ? addButtonText.textContent : addButton.textContent;

//     const selectedInputs = getSelectedInputs();
//     const selectedItems = getSelectedItems(selectedInputs).sort((a, b) => a.localeCompare(b));
//     const selectedSize = getSelectedSize();

//     if (selectedItems.length === 0) {
//       showBundleError('⚠️ Please add at least one item to your bundle.');
//       return;
//     }

//     if (!selectedSize) {
//       showBundleError('⚠️ Please choose a size.');
//       return;
//     }

//     const matchedVariant = findMatchedVariant(selectedItems);

//     if (!matchedVariant) {
//       showBundleError('⚠️ This bundle combination is not available.');
//       return;
//     }

//     if (!matchedVariant.available) {
//       showBundleError('⚠️ This bundle is currently unavailable.');
//       return;
//     }

//     const totalCents = Number(addButton.dataset.totalCents || 0);

//     const lineItemProperties = {
//       Size: selectedSize,
//       Items: selectedItems.join(', '),
//       _bundle_total: formatMoney(totalCents),
//       ...(frontDringInput?.checked
//         ? { 'Front D-Ring': 'Yes' }
//         : {}),
//       ...getEngravingProperties(),
//     };

//     addButton.disabled = true;
//     if (addButtonText) addButtonText.textContent = 'Adding...';
//     else addButton.textContent = 'Adding...';

//     let success = false;

//     // try {
//     //   const response = await fetch('/cart/add.js', {
//     //     method: 'POST',
//     //     headers: {
//     //       'Content-Type': 'application/json',
//     //       Accept: 'application/json',
//     //     },
//     //     body: JSON.stringify({
//     //       items: [
//     //         {
//     //           id: matchedVariant.id,
//     //           quantity: 1,
//     //           properties: lineItemProperties,
//     //         },
//     //       ],
//     //     }),
//     //   });
// try {
//   const cartItems = [];

//   if (frontDringInput?.checked) {
//     cartItems.push({
//       id: FRONT_DRING_VARIANT_ID,
//       quantity: 1,
//       properties: {
//         _type: 'Front D-Ring Upgrade',
//         _bundle_variant: String(matchedVariant.id),
//       },
//     });
//   }
// cartItems.push({
//   id: matchedVariant.id,
//   quantity: 1,
//   properties: lineItemProperties,
// });
//   const response = await fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//     },
//     body: JSON.stringify({
//       items: cartItems,
//     }),
//   });

//   const data = await response.json();




//       if (!response.ok) {
//         showBundleError(data.description || 'Failed to add items to cart.');
//         return;
//       }

//       success = true;

//       if (addButtonText) addButtonText.textContent = 'Added to cart';
//       else addButton.textContent = 'Added to cart';

//       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
//     } catch (error) {
//       console.error('Bundle add-to-cart failed:', error);
//       showBundleError('Something went wrong. Please try again.');
//     } finally {
//       setTimeout(
//         () => {
//           addButton.disabled = false;
//           if (addButtonText) addButtonText.textContent = originalText;
//           else addButton.textContent = originalText;
//         },
//         success ? 1200 : 0
//       );
//     }
//   });

//   bundleInputs.forEach((input) => {
//     input.checked = true;
//   });

//   refreshBundleUI();
// });
function initializeDDPawsBundle() {
  const firstMediaThumb = document.querySelector('[data-media-position="1"]');
  if (firstMediaThumb) {
    requestAnimationFrame(() => firstMediaThumb.click());
  }

  const addButton = document.getElementById('bundle-add-to-cart');
  const variantJsonEl = document.getElementById('bundle-variants-json');
  const selectedTextEl = document.getElementById('bundle-selected-text');
  const originalTotalEl = document.getElementById('bundle-total-original');
  const finalTotalEl = document.getElementById('bundle-total');
  const selectAllCard = document.getElementById('bundle-select-all');
  const packFillEl = document.getElementById('bundle-pack-fill');
  const frontDringInput = document.getElementById('front-dring');
  const frontDringWrapper = document.getElementById('front-dring-wrapper');

  const FRONT_DRING_ENABLED = false;
  const FRONT_DRING_VARIANT_ID = 49176654020863;
  const errorMessageEl = document.querySelector('.bundle-error-message');

  const bundleInputs = Array.from(document.querySelectorAll('.bundle-item'));
  const bundleCards = Array.from(document.querySelectorAll('.bundle-card'));
  const sizeContainer = document.querySelector('.bundle-sizes');
  if (!sizeContainer) return;
  if (!sizeContainer.querySelector('input[value="Not sure"]')) {
    const label = document.createElement('label');
    label.className = 'bundle-size-option';
    label.innerHTML = '<input type="radio" name="bundle-size" value="Not sure"><span>Not sure</span>';
    sizeContainer.append(label);
  }
  const assistanceStyle = document.createElement('style');
  assistanceStyle.textContent = `
    .bundle-sizes { flex-wrap: wrap; }
    #ddp-sizing-dialog { box-sizing:border-box; width:min(520px, calc(100vw - 28px)); max-height:calc(100dvh - 40px); overflow:auto; border:1px solid #ded8ce; border-radius:20px; padding:24px; background:#F2EEE6; color:#2E2220; }
    #ddp-sizing-dialog::backdrop { background:rgba(0,0,0,.45); }
    #ddp-sizing-dialog h2 { margin:0 32px 10px 0; font-size:24px; }
    #ddp-sizing-dialog p { font-size:14px; line-height:1.5; }
    #ddp-sizing-dialog fieldset { border:1px solid #d4cec3; border-radius:12px; padding:14px; margin:18px 0; min-width:0; }
    #ddp-sizing-dialog legend { font-weight:700; font-size:15px; }
    #ddp-sizing-dialog label { display:block; margin:10px 0; font-size:14px; }
    #ddp-sizing-dialog input, #ddp-sizing-dialog select { box-sizing:border-box; min-width:0; width:100%; padding:10px; border:1px solid #aaa99f; border-radius:8px; background:#fff; color:#2E2220; font:inherit; font-size:16px; }
    #ddp-sizing-dialog .ddp-unit-row { display:grid; grid-template-columns:minmax(0,1fr) 90px; gap:8px; }
    #ddp-sizing-dialog .ddp-close { position:absolute; right:12px; top:10px; padding:4px 10px; background:transparent; border:0; color:#2E2220; font-size:26px; cursor:pointer; }
    #ddp-sizing-dialog .ddp-save { width:100%; padding:13px; border:0; border-radius:10px; background:#3E4F46; color:white; font:inherit; cursor:pointer; }
    #ddp-sizing-dialog .ddp-error { color:#9a2525; }
    #ddp-sizing-summary { margin:10px 0; font-size:13px; color:#3E4F46; }
    #ddp-sizing-edit { background:transparent; border:0; padding:4px 0; color:#3E4F46; text-decoration:underline; cursor:pointer; font:inherit; }
    #ddp-sizing-dialog :focus-visible, #ddp-sizing-edit:focus-visible { outline:2px solid #3E4F46; outline-offset:3px; }
    #ddp-sizing-dialog .ddp-sizing-or {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  color: #3E4F46;
  font-weight: 700;
}

#ddp-sizing-dialog .ddp-sizing-or::before,
#ddp-sizing-dialog .ddp-sizing-or::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #d4cec3;
}
  `;
  document.head.append(assistanceStyle);
  const sizingDialog = document.createElement('dialog');
  sizingDialog.id = 'ddp-sizing-dialog';
  sizingDialog.setAttribute('aria-labelledby', 'ddp-sizing-title');
  sizingDialog.innerHTML = `
    <button type="button" class="ddp-close" aria-label="Close sizing help">×</button>
    <h2 id="ddp-sizing-title">Let’s find their best fit</h2>
    <p>Not sure which size to choose? Share either your dog’s breed and weight or their neck and chest measurements. You can fill in both for extra guidance.</p>
    <form id="ddp-sizing-form" novalidate>
      <fieldset>
        <legend>Breed &amp; weight</legend>
        <label>Dog breed or mix<input name="breed" type="text" maxlength="100" placeholder="e.g. French Bulldog"></label>
        <label>Weight<span class="ddp-unit-row"><input name="weight" type="number" min="0.01" step="any" inputmode="decimal" aria-label="Dog weight"><select name="weightUnit" aria-label="Weight unit"><option value="lb">lb</option><option value="kg">kg</option></select></span></label>
      </fieldset>
      <p class="ddp-sizing-or">Or</p>
      <fieldset>
        <legend>Neck &amp; chest measurements</legend>
        <label>Measurement unit<select name="lengthUnit"><option value="in">Inches (in)</option><option value="cm">Centimeters (cm)</option></select></label>
        <label>Neck circumference<input name="neck" type="number" min="0.01" step="any" inputmode="decimal"></label>
        <label>Chest circumference<input name="chest" type="number" min="0.01" step="any" inputmode="decimal"></label>
        <p>Measure around the neck where the collar sits and around the widest part of the chest, just behind the front legs.</p>
      </fieldset>
      <p>We’ll include these details with your order so our team can help select a size. Breed and weight provide an estimate; measurements help us assess the fit more accurately.</p>
      <p class="ddp-error" role="alert" id="ddp-sizing-error" hidden></p>
      <button type="submit" class="ddp-save">Save sizing details</button>
    </form>
  `;
  document.body.append(sizingDialog);
  const sizingForm = sizingDialog.querySelector('form');
  const sizingError = sizingDialog.querySelector('#ddp-sizing-error');
  const sizingSummary = document.createElement('div');
  sizingSummary.id = 'ddp-sizing-summary';
  sizingSummary.hidden = true;
  const summaryText = document.createElement('div');
  const editSizing = document.createElement('button');
  editSizing.type = 'button';
  editSizing.id = 'ddp-sizing-edit';
  editSizing.textContent = 'Edit sizing details';
  sizingSummary.append(summaryText, editSizing);
  sizeContainer.after(sizingSummary);
  let savedSizing = null;
  let previousSize = sizeContainer.querySelector('input:checked')?.value || '';
  let sizingConfirmed = false;
  let sizingDraft = [];
  function openSizingDialog() {
    sizingDraft = Array.from(sizingForm.elements).filter(field => field.name).map(field => [field.name, field.value]);
    sizingConfirmed = false;
    sizingError.hidden = true;
    if (!sizingDialog.open) sizingDialog.showModal();
  }
  function renderSizingSummary() {
    const needsHelp = sizeContainer.querySelector('input:checked')?.value === 'Not sure';
    sizingSummary.hidden = !needsHelp || !savedSizing;
    if (savedSizing) summaryText.textContent = Object.entries(savedSizing).filter(([key]) => key !== 'Sizing assistance').map(([key, value]) => key + ': ' + value).join(' · ');
  }
  sizeContainer.addEventListener('change', function (event) {
    if (!event.target.matches('input[name="bundle-size"]')) return;
    if (event.target.value === 'Not sure') openSizingDialog();
    else previousSize = event.target.value;
    renderSizingSummary();
  });
  editSizing.addEventListener('click', openSizingDialog);
  sizingDialog.querySelector('.ddp-close').addEventListener('click', () => sizingDialog.close());
  sizingDialog.addEventListener('click', function (event) {
    if (event.target !== sizingDialog) return;
    const rect = sizingDialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) sizingDialog.close();
  });
  sizingDialog.addEventListener('close', function () {
    if (!sizingConfirmed) sizingDraft.forEach(([name, value]) => { sizingForm.elements.namedItem(name).value = value; });
    if (!sizingConfirmed && !savedSizing) {
      sizeContainer.querySelectorAll('input[name="bundle-size"]').forEach(input => { input.checked = input.value === previousSize; });
      sizeContainer.querySelector('input:checked')?.dispatchEvent(new Event('change', { bubbles: true }));
    }
    renderSizingSummary();
  });
  sizingForm.addEventListener('submit', function (event) {
    event.preventDefault();
    const fields = sizingForm.elements;
    const breed = fields.breed.value.trim();
    const weight = fields.weight.value.trim();
    const neck = fields.neck.value.trim();
    const chest = fields.chest.value.trim();
    const positive = value => value !== '' && Number.isFinite(Number(value)) && Number(value) > 0;
    const completeBreed = Boolean(breed && positive(weight));
    const completeMeasurements = positive(neck) && positive(chest);
    if ((!completeBreed && !completeMeasurements) || !sizingForm.checkValidity()) {
      sizingError.textContent = 'Please complete either breed and weight, or both neck and chest measurements. Any numbers entered must be greater than zero.';
      sizingError.hidden = false;
      return;
    }

    savedSizing = { 'Sizing assistance': 'Needed — size not confirmed' };

    if (breed) savedSizing['Dog breed'] = breed;
    if (positive(weight)) {
      savedSizing['Dog weight'] = weight + ' ' + fields.weightUnit.value;
    }
    if (positive(neck)) {
      savedSizing['Dog neck'] = neck + ' ' + fields.lengthUnit.value;
    }
    if (positive(chest)) {
      savedSizing['Dog chest'] = chest + ' ' + fields.lengthUnit.value;
    }
    sizingConfirmed = true;
    sizingDialog.close();
    renderSizingSummary();
  });

  const sizeInputs = Array.from(document.querySelectorAll('input[name="bundle-size"]'));
  const packOptions = Array.from(document.querySelectorAll('.bundle-pack-option'));

  if (!addButton || !variantJsonEl || !finalTotalEl || !bundleInputs.length || addButton.dataset.ddpInitialized === 'true') return;
  addButton.dataset.ddpInitialized = 'true';

  let variants = [];

  try {
    variants = JSON.parse(variantJsonEl.textContent);
  } catch (error) {
    console.error('Invalid bundle variants JSON:', error);
    return;
  }
  function bundleIncludesHarness(selectedItems) {
    return selectedItems
      .map(normalizeItemName)
      .some((item) => item === 'harness' || item === 'vest');
  }
  function updateFrontDringVisibility(selectedItems) {
    if (!frontDringWrapper || !frontDringInput) return;

    // Temporarily disable Front D-Ring feature
    if (!FRONT_DRING_ENABLED) {
      frontDringWrapper.style.display = 'none';
      frontDringInput.checked = false;
      return;
    }

    const hasHarness = bundleIncludesHarness(selectedItems);

    frontDringWrapper.style.display = hasHarness ? '' : 'none';

    if (!hasHarness) {
      frontDringInput.checked = false;
    }
  }
  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function getSelectedSize() {
    const checked = sizeInputs.find((input) => input.checked);
    return checked ? checked.value : '';
  }

  function getSelectedInputs() {
    return bundleInputs.filter((input) => input.checked);
  }

  function getSelectedItems(selectedInputs) {
    return selectedInputs.map((input) => input.value);
  }

  function getDiscountRate(itemCount) {
    if (itemCount >= 4) return 0.2;
    if (itemCount === 3) return 0.15;
    if (itemCount === 2) return 0.1;
    return 0;
  }

  function getBasePriceFromInput(input) {
    const card = input.closest('.bundle-card');
    return Number(card?.dataset.priceCents || 0);
  }

  function getLivePriceCents(basePriceCents, discountRate) {
    return Math.round(basePriceCents * (1 - discountRate));
  }

  function normalizeItemName(name) {
    return String(name).trim().toLowerCase();
  }

  function getBundleCounts(selectedItems) {
    const c1Items = ['collar', 'leash'];
    const c2Items = ['harness', 'vest'];
    const c3Items = ['bowtie', 'flower', 'bandana', 'poop bag holder'];

    let c1 = 0;
    let c2 = 0;
    let c3 = 0;

    selectedItems.map(normalizeItemName).forEach((item) => {
      if (c1Items.includes(item)) c1++;
      else if (c2Items.includes(item)) c2++;
      else if (c3Items.includes(item)) c3++;
    });

    return { c1, c2, c3 };
  }

  function getBundleKey(selectedItems) {
    const counts = getBundleCounts(selectedItems);
    return 'Bundle | C1-' + counts.c1 + ' | C2-' + counts.c2 + ' | C3-' + counts.c3;
  }

  function findMatchedVariant(selectedItems) {
    const bundleKey = getBundleKey(selectedItems);
    return variants.find((variant) => variant.title === bundleKey);
  }

  function showBundleError(message) {
    if (!errorMessageEl) return;

    errorMessageEl.textContent = message;
    errorMessageEl.classList.add('is-visible');

    setTimeout(() => {
      errorMessageEl.classList.remove('is-visible');
    }, 3000);
  }

  function updateSelectedText(selectedItems) {
    if (!selectedTextEl) return;
    selectedTextEl.textContent = selectedItems.length ? selectedItems.join(', ') : 'None selected';
  }

  function updateCards(discountRate) {
    bundleCards.forEach((card) => {
      const input = card.querySelector('.bundle-item');
      const priceEl = card.querySelector('[data-price-text]');
      if (!input || !priceEl) return;

      card.classList.toggle('is-selected', input.checked);

      const basePriceCents = Number(card.dataset.priceCents || 0);
      const livePriceCents = getLivePriceCents(basePriceCents, discountRate);

      if (discountRate > 0) {
        priceEl.innerHTML =
          '<span class="compare-price">' + formatMoney(basePriceCents) + '</span>' +
          '<span class="sale-price">' + formatMoney(livePriceCents) + '</span>';
      } else {
        priceEl.textContent = formatMoney(basePriceCents);
      }
    });
  }

  function updateTotal(selectedInputs, discountRate) {
    let originalTotalCents = 0;
    let finalTotalCents = 0;

    selectedInputs.forEach((input) => {
      const basePriceCents = getBasePriceFromInput(input);
      const livePriceCents = getLivePriceCents(basePriceCents, discountRate);

      originalTotalCents += basePriceCents;
      finalTotalCents += livePriceCents;
    });

    if (originalTotalEl) {
      if (discountRate > 0 && originalTotalCents > finalTotalCents) {
        originalTotalEl.textContent = formatMoney(originalTotalCents);
        originalTotalEl.style.display = 'inline';
      } else {
        originalTotalEl.textContent = '';
        originalTotalEl.style.display = 'none';
      }
    }

    finalTotalEl.textContent = formatMoney(finalTotalCents);
    addButton.dataset.totalCents = finalTotalCents;
  }

  function updatePackBar(selectedCount) {
    let fillPercent = 0;
    let activeCount = 0;

    if (selectedCount >= 4) {
      fillPercent = 100;
      activeCount = 3;
    } else if (selectedCount === 3) {
      fillPercent = 66.6667;
      activeCount = 2;
    } else if (selectedCount === 2) {
      fillPercent = 33.3333;
      activeCount = 1;
    }

    if (packFillEl) {
      packFillEl.style.width = fillPercent + '%';
    }

    packOptions.forEach((option, index) => {
      option.classList.toggle('active', index < activeCount);
    });
  }

  function updateSelectAllState() {
    if (!selectAllCard) return;

    const allSelected = bundleInputs.length > 0 && bundleInputs.every((input) => input.checked);
    selectAllCard.classList.toggle('is-active', allSelected);
  }

  function refreshBundleUI() {
    const selectedInputs = getSelectedInputs();
    const selectedItems = getSelectedItems(selectedInputs);
    const discountRate = getDiscountRate(selectedInputs.length);

    updateSelectedText(selectedItems);
    updateCards(discountRate);
    updateTotal(selectedInputs, discountRate);
    updatePackBar(selectedInputs.length);
    updateSelectAllState();
    updateFrontDringVisibility(selectedItems);
  }

  function getEngravingProperties() {
    let payload = null;

    try {
      payload = window.__engravingLoadSaved ? window.__engravingLoadSaved() : null;
    } catch (error) {
      console.error('Could not load engraving payload:', error);
    }

    if (!payload) return {};

    const props = {};

    if (payload.line1) props['Engraving Line 1'] = payload.line1;
    if (payload.line2) props['Engraving Line 2'] = payload.line2;
    if (payload.line3) props['Engraving Line 3'] = payload.line3;
    if (payload.font) props['Engraving Font'] = payload.font;
    if (payload.buckleColor) props['Buckle Color'] = payload.buckleColor;

    return props;
  }

  if (selectAllCard) {
    selectAllCard.addEventListener('click', function () {
      const allSelected = bundleInputs.every((input) => input.checked);

      bundleInputs.forEach((input) => {
        input.checked = !allSelected;
      });

      refreshBundleUI();
    });
  }

  [...bundleInputs, ...sizeInputs].forEach((input) => {
    input.addEventListener('change', refreshBundleUI);
  });

  addButton.addEventListener('click', async function () {
    if (addButton.disabled) return;

    const addButtonText = addButton.querySelector('.atc-text');
    const originalText = addButtonText ? addButtonText.textContent : addButton.textContent;

    const selectedInputs = getSelectedInputs();
    const selectedItems = getSelectedItems(selectedInputs).sort((a, b) => a.localeCompare(b));
    const selectedSize = getSelectedSize();

    if (selectedItems.length === 0) {
      showBundleError('⚠️ Please add at least one item to your bundle.');
      return;
    }

    if (!selectedSize) {
      showBundleError('⚠️ Please choose a size.');
      return;
    }

    if (selectedSize === 'Not sure' && !savedSizing) {
      showBundleError('Please save your dog’s sizing details first.');
      openSizingDialog();
      return;
    }

    const matchedVariant = findMatchedVariant(selectedItems);

    if (!matchedVariant) {
      showBundleError('⚠️ This bundle combination is not available.');
      return;
    }

    if (!matchedVariant.available) {
      showBundleError('⚠️ This bundle is currently unavailable.');
      return;
    }

    const totalCents = Number(addButton.dataset.totalCents || 0);

    const lineItemProperties = {
      Size: selectedSize,
      ...(selectedSize === 'Not sure' ? savedSizing : {}),
      Items: selectedItems.join(', '),
      _bundle_total: formatMoney(totalCents),
      ...(frontDringInput?.checked
        ? { 'Front D-Ring': 'Yes' }
        : {}),
      ...getEngravingProperties(),
    };

    addButton.disabled = true;
    if (addButtonText) addButtonText.textContent = 'Adding...';
    else addButton.textContent = 'Adding...';

    let success = false;

try {
  const cartItems = [];

  if (frontDringInput?.checked) {
    cartItems.push({
      id: FRONT_DRING_VARIANT_ID,
      quantity: 1,
      properties: {
        _type: 'Front D-Ring Upgrade',
        _bundle_variant: String(matchedVariant.id),
      },
    });
  }
cartItems.push({
  id: matchedVariant.id,
  quantity: 1,
  properties: lineItemProperties,
});
  const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      items: cartItems,
    }),
  });

  const data = await response.json();




      if (!response.ok) {
        showBundleError(data.description || 'Failed to add items to cart.');
        return;
      }

      success = true;

      if (addButtonText) addButtonText.textContent = 'Added to cart';
      else addButton.textContent = 'Added to cart';

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      console.error('Bundle add-to-cart failed:', error);
      showBundleError('Something went wrong. Please try again.');
    } finally {
      setTimeout(
        () => {
          addButton.disabled = false;
          if (addButtonText) addButtonText.textContent = originalText;
          else addButton.textContent = originalText;
        },
        success ? 1200 : 0
      );
    }
  });

  bundleInputs.forEach((input) => {
    input.checked = true;
  });

  refreshBundleUI();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeDDPawsBundle, { once: true });
} else {
  initializeDDPawsBundle();
}